import { myChannelListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const myChannelListRouteMetadata: IRouteMetadataObj<
  typeof myChannelListRoutesObj
> = {
  list: {
    title: "myChannelList.index.title",
    description: "myChannelList.index.description",
    lazy: () => import("@/pages/studentPages/myChannelList/table/page"),
    mode: "index",
    type: "main",
    icon: "BookLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "myChannelList.view.title",
    description: "myChannelList.view.description",
    lazy: () => import("@/pages/chat/page"),
    mode: "view",
    type: "inner",
    icon: "Message3Line",
    breadcrumbs: [],
    permission,
    isPageFullMode: true,
  },
};

export const myChannelListRoutes = createRoute<typeof myChannelListRoutesObj>(
  myChannelListRoutesObj,
  myChannelListRouteMetadata,
);
